import * as React from 'react';
import { AppDrawerToolbarButton } from '../../../../web/components-v2/Drawer/AppDrawer';
import { SparklesIcon } from '../../../../web/components/svgs/icons/SparklesIcon';
import { TYSON_COACHING_DRAWER_VALUE } from '../../../components/Queue';

interface TysonCoachingDropdownProps {
	disabled?: boolean;
}

export const TysonCoachingDropdown: React.FC<TysonCoachingDropdownProps> = ({ disabled }) => {
	return (
		<AppDrawerToolbarButton value={TYSON_COACHING_DRAWER_VALUE} tooltip='AI Coaching' disabled={disabled}>
			<SparklesIcon />
		</AppDrawerToolbarButton>
	);
};
